import { render, staticRenderFns } from "./AddUserModal.vue?vue&type=template&id=23bafebe&scoped=true"
import script from "./AddUserModal.vue?vue&type=script&lang=js"
export * from "./AddUserModal.vue?vue&type=script&lang=js"
import style0 from "./AddUserModal.vue?vue&type=style&index=0&id=23bafebe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bafebe",
  null
  
)

export default component.exports